export default __webpack_public_path__ + "static/media/bot.46643169.png";